import "./Five-Million.css";
// import cancelIcon from "/Xicon.png";
import milions from "../../../../assets/images/5millions.svg";
import ReferPage from "../../../ReferPage/ReferPage";
import useUserInfo from "../../../../Hooks/useUserInfo";

export const FiveMillionPopup = (props) => {
    const { userDetails, updateUserInfo } =
    useUserInfo();
    const CloseFunc =()=>{
        props?.setIs5million(false); // Hide the popup
    localStorage.setItem(`IsPointsReach${props?.userId}`, "false");
      }
      const goToThePage = (component, name) => {
        updateUserInfo((prev) => ({
          ...prev,
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails.currentComponent,
          lastComponentText: userDetails.currentComponentText,
          centerCount: userDetails.centerCount + 1,
        }));
      };
      const NavigatePage=()=>{
        goToThePage(ReferPage, "ReferPage")
      }
  return (
    <>
      <div class="spinning-animation-sv"></div>
      <div className="row" style={{ position: "relative", maxWidth: "280px" }}>
        <div class="background-card-sv"></div>
        <div
          className="content-card-sv p-2"
          style={{ borderRadius: "13px", border: "1px solid #4CF038" }}
        >
          <div style={{ position: "relative", width: "100%" }}>
            <h1 className="whats-new-mil p-2" data-text="WHAT'S NEW">
              YOU'RE A LEGEND!
            </h1>
            <img className=""
              src={milions}
              style={{
                zIndex: "1",
                width: "100%",
                height: "100%",
                display: "block",
                // borderRadius: "24px",
              }}
              alt="Background"
            />
          </div>

          <div className="text_container-sv">
            <p className="pre_text-mil mb-0">
              You've hit the limit for Watch & Earn, Play & Earn, Do & Earn, and
              Streak & Earn
            </p>
            <p className="pre_text-mil mb-3 bg-blue ">
              But the rewards don’t stop, keep earning by inviting friends!
            </p>
          </div>
          <button
            onClick={NavigatePage}
            className="redeem-button-mil col-10"
          >
            Invite & Earn Now
          </button>
        </div>
        <button
          style={{
            background: "transparent",
            border: "none",
            height: "24px",
          }}
        >
          <img
            onClick={CloseFunc}
            src={"/Xicon.png"}
            className="cancel_button-sv"
          />
        </button>
      </div>
    </>
  );
};
